import React from "react";
import './price.css';

export default function Price(props) {
    return(
        <div className="price">
            <div className="priceBox">
                <h3 className="textPurple">{ props.title }</h3>
            </div>
            <div className="priceBox">
                <p>{ props.text }</p>
            </div>
            <div className="priceBox">
                <p>{ props.text2 }</p>
            </div>
            <div className="priceBox">
                <p className="textPurple textPrice">{ props.price }</p>
                { props.text3 && <p className="textBottom">{ props.text3 }</p>}
            </div>
        </div>
    )
}